// InputsContext.js
import React, { createContext} from 'react';

// Create a context to hold the inputs state
const InputsContext = createContext();

export default InputsContext;